var exports = {
  "u": "xe533113f--33d7f5--filters",
  "h": "xe533113f--33d7f5--feed",
};

module.exports = exports;
